import React, { useState } from 'react'

import mixpanel from 'mixpanel-browser';

import { Button, Divider, Grid, Icon, } from 'semantic-ui-react'

import { Container } from 'semantic-ui-react'

import { useNavigate } from 'react-router-dom'
import OptionsModal from 'draft/modals/optionsModal'

import Header from 'components/header'
import Section from './section'

import { LazyLoadImage } from 'react-lazy-load-image-component';

import draftExampple from './images/draftExample.png'
import draftThumbnail from './images/draft_thumbnail.jpg'
import tourExample from './images/tourExample.png'
import tourThumbnail from './images/tour_thumbnail.jpg'

import VippsQRModal from './vippsModal/vippsQrModal'
import DraftExample from './draftExample';
import { getRandomInt } from 'draft/utils/drafter';
import { GameType } from 'draft/types';

import { Brand, getBrand } from 'common/brand'

const Home = () => {
    const [optionsModalOpen, setOptionsModalOpen] = useState(false);

    const navigate = useNavigate();

    mixpanel.track("Home Visited")


    const tutorialOnClick = () => {
        window.scrollTo(0, 0);
        navigate('tutorial');
    }

    const brand = getBrand();


    const fredMail = "fredrik.kloster93@gmail.com";
    const subject = `${brand} Feedback`;

    const sections = () => (
        <>
            <div style={{
                margin: '6em 0px 6em 0px',
                padding: '0 25% 0 25%'
            }}>
                <h3>New way to play Super Smash</h3>
                <p>
                    Custom drafting system and a new format for 2vs2 tournaments.
                </p>
            </div>

            <Grid className='computer and up' columns='equal' style={{ margin: '6em 0px 6em 0px' }}>
                <Grid.Row only='computer'>
                    <Grid.Column>
                        <DraftExample
                            color='red'
                            gameType={GameType.Melee}
                        />
                    </Grid.Column>
                    <Grid.Column>
                        <DraftExample
                            color='blue'
                            gameType={GameType.Melee}
                        />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row only='mobile tablet' centered>
                    <Grid.Column mobile={14}>
                        <DraftExample
                            color={getRandomInt(2) === 1 ? 'blue' : 'red'}
                            gameType={GameType.Melee}
                        />
                    </Grid.Column>
                </Grid.Row>
            </Grid>

            <Divider />

            <Section
                header='Tournament'
                text={`
                    A ${brand} tournament is a 2vs2 bonanza, where every player is paired up with a new 
                    teammate every game. Gather some friends, and easily host a tournament with custom
                    setup. The drafting system is fully integrated, and each draft is initiated directly from the tournament games. 
                    `}
            >
                <div style={{ width: '50%', margin: 'auto' }}>
                    <LazyLoadImage
                        style={{
                            maxWidth: '100%',
                            borderRadius: '1rem',
                            border: '0.25px solid #46607a'
                        }}
                        src={tourExample}
                        placeholderSrc={tourThumbnail}
                        alt="Tournament"
                    />
                </div>
            </Section>

            <Divider />

            <Section
                header='Draft'
                text='
                Players are assigned 3 random heroes to pick from, and a stage for the match. 
                Each team have the ability to ban
                1 hero from the opponent team. Additionally, 3 Item Cards are drawn, which are purchasable by 
                drinking. Item Cards triggers actions like rerolling your heroes, or getting an extra ban.
                '
            >
                <div style={{ width: '50%', margin: 'auto' }}>
                    <LazyLoadImage
                        style={{
                            maxWidth: '100%',
                            borderRadius: '1rem',
                            border: '0.25px solid #46607a'
                        }}
                        src={draftExampple}
                        placeholderSrc={draftThumbnail}
                        alt={"Drafting"}
                    />
                </div>
            </Section>

            <Divider />



            <Section
                header='Custom Rules'
                text={`
                    ${getBrand()} also includes a set of suggestive rules to spice up the game.
                    Read more about the draft and custom in-game rules here. Take a look at the compendium to 
                    see the different Item Cards and stages available for the draft.  
                    `}
            >
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '2em',
                    flexWrap: 'wrap',
                    marginBottom: '4em'
                }}>
                    <Button
                        onClick={() => tutorialOnClick()}
                        basic
                        size='big'
                        icon className='melee'
                        labelPosition='left'
                    >
                        <Icon name='student' />
                        Tutorial
                    </Button>
                </div>
            </Section>

            <Divider />

            <Section
                header='Contact and support'
                text="
        I'm a solo hobbyist who made this system for Super Smash Melee out of enthusiasm and love for the game.
        If you have any questions or suggestions, don't hesitate to reach out. This project is still under development, 
        and will hopefully release new features frequently. 
                "
            />
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '2em',
                flexWrap: 'wrap',
                marginBottom: '4em'
            }}>
                <Button
                    href={`mailto:${fredMail}?subject=${subject}`}
                    basic
                    size='big'
                    icon className='melee'
                    labelPosition='left'
                >
                    <Icon name='mail' />
                    Email
                </Button>
                {brand === Brand.Fyllamelee ? (
                    <VippsQRModal />
                ) : (
                    <Button
                        href={`https://www.buymeacoffee.com/smashedgg`}
                        target='_blank'
                        basic
                        size='big'
                        icon className='melee'
                        labelPosition='left'
                    >
                        <Icon name='heart' />
                        Buy me a beer
                    </Button>
                )}
            </div>
        </>
    )


    return (
        <>
            <div className="melee-wrapper">
                <Container className='regularText' style={{ paddingTop: 10, paddingBottom: 10 }}>

                    <Header
                        helmet={brand}
                    />

                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: '1em',
                        flexWrap: 'wrap'
                    }}>
                        <Button
                            onClick={() => navigate('create')}
                            basic
                            icon className='melee'
                            labelPosition='left'
                        >
                            <Icon name='winner' />
                            Create Tournmanet
                        </Button>

                        <Button onClick={() => navigate('tournaments')}
                            basic
                            icon className='melee'
                            labelPosition='left'
                        >
                            <Icon name='list' />

                            Tournaments
                        </Button>

                        <Button onClick={() => navigate('draft')}
                            basic
                            icon className='melee'
                            labelPosition='left'
                        >
                            <Icon name='game' />
                            Draft
                        </Button>

                        <Button onClick={() => navigate('tutorial')}
                            basic
                            icon className='melee'
                            labelPosition='left'
                        >
                            <Icon name='student' />
                            Tutorial
                        </Button>

                        <Button onClick={() => navigate('compendium')}
                            basic
                            icon className='melee'
                            labelPosition='left'
                        >
                            <Icon name='book' />
                            Compendium
                        </Button>
                    </div>
                    <Divider />

                    {sections()}
                    <OptionsModal
                        open={optionsModalOpen}
                        setOpen={setOptionsModalOpen}
                    />
                </Container>

            </div>
        </>
    )
}

export default Home;